import { UserRole } from '@/constants/statuses'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    currentUser: null,
    accessToken: '',
    roles: [],
    eduGroup: null,
    errorMsg: ''
  },

  getters: {
    isLoggedIn: state => !!state.accessToken,
    userName: state => state.currentUser?.username || '',
    errorMsg: state => state.errorMsg,
    hasRoles: state => !!state.roles?.length,
    adminRole: (state) => state.roles.includes(UserRole.admin),
    editorScheduleRole: (state) =>
      _.some([UserRole.editor_schedule, UserRole.admin], el => _.includes(state.roles, el)),
    editorClassroomsRole: (state) =>
      _.some([UserRole.editor_classrooms, UserRole.admin], el => _.includes(state.roles, el)),
    editorTeachersRole: (state) =>
      _.some([UserRole.editor_teachers, UserRole.admin], el => _.includes(state.roles, el)),
    studentRole: (state) => state.roles?.length === 1 && state.roles?.[0] === UserRole.viewer_student
  },

  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user
    },
    addRole(state, role) {
      state.roles.push(role)
    },
    addGroup(state, group) {
      state.eduGroup = group
    },
    setErrorMsg(state, msg) {
      state.errorMsg = msg
    },
    setAccessToken(state, token) {
      state.accessToken = token
    }
  }
}
